import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_INTERPRETER_TOOLS_MOUNTED, SET_INTERPRETER_TOOLS_OPEN, SET_INTERPRETER_TOOLS_TRANSFER_PENDING } from './actionTypes';
const DEFAULT_STATE = {
    mounted: false,
    open: false,
    transferPending: false
};
/**
 * The interpreter's Tools panel (web).
 *
 * @param {IInterpreterToolsState} state - The current state.
 * @param {Object} action - The action.
 * @returns {IInterpreterToolsState}
 */
export function interpreterToolsReducer(state = DEFAULT_STATE, action) {
    switch (action.type) {
        case SET_INTERPRETER_TOOLS_MOUNTED:
            return action.mounted ? {
                ...state,
                mounted: true
            } : DEFAULT_STATE;
        case SET_INTERPRETER_TOOLS_OPEN:
            return state.mounted ? {
                ...state,
                open: Boolean(action.open)
            } : state;
        case SET_INTERPRETER_TOOLS_TRANSFER_PENDING:
            return {
                ...state,
                transferPending: Boolean(action.pending)
            };
    }
    return state;
}
ReducerRegistry.register('features/interpreter-tools', interpreterToolsReducer);
